import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=5a9bfcf7"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=5a9bfcf7&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a9bfcf7')) {
      api.createRecord('5a9bfcf7', component.options)
    } else {
      api.reload('5a9bfcf7', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=5a9bfcf7", function () {
      api.rerender('5a9bfcf7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/creditInfo/informationPublish/detail.vue"
export default component.exports